import scriptLoaderUtil from './ScriptLoaderUtil';
import { FEEFO_POPUP_SCRIPT_ID } from '../constants/ReviewConstants';
export const loadFeefoScript = (feefoIdentifier) => {
    scriptLoaderUtil.loadScript(`https://api.feefo.com/api/javascript/${feefoIdentifier}`, FEEFO_POPUP_SCRIPT_ID);
};
